export const novels = [
  {
    id: 1,
    title: "霸总的替身前妻",
    author: "苏小暖",
    category: "霸总",
    slug: "霸道总裁",
    description: "结婚三年，她以为他对她至少有一丝情意。直到那天，他的白月光回国，她才知道自己不过是一个替身。她递上离婚协议，他却红了眼眶：「别走。」可她已经不想再做任何人的影子。",
    rating: 4.8,
    reads: 1250000,
    tags: ["替身", "先婚后爱", "追妻火葬场"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20romance%20novel%20cover%20featuring%20a%20handsome%20CEO%20in%20a%20dark%20suit%2C%20soft%20rose%20gold%20lighting%2C%20elegant%20minimalist%20design%20with%20cherry%20blossom%20petals%20floating%2C%20warm%20romantic%20atmosphere%20on%20a%20cream%20background&width=400&height=560&seq=novel-cover-01&orientation=portrait",
    featured: true,
    rank: 1,
    content: `<h2>第一章 替身</h2><p>结婚三年，林知意一直以为自己嫁给了爱情。顾衍之对她算不上温柔体贴，但也从未苛待过她。他会在她生日时送昂贵的礼物，会记得她的口味偏好，偶尔也会在深夜回家时，轻轻吻一下她的额头。</p><p>她以为这就是他的方式——不善言辞，却用行动表达着在乎。直到那天，她在他的书房里发现了一张照片。照片上的女孩穿着白裙，笑容明媚，眉眼之间，竟与自己有七分相似。照片背面写着一行字：「念安，永远等你回来。」</p><p>苏念安。林知意的手微微发抖。她听说过这个名字——顾衍之的初恋，三年前出国留学，至今未归。而她和顾衍之结婚，正好是三年。</p><h2>第二章 白月光归来</h2><p>那天晚上，顾衍之接了一个电话后，神色明显变了。他匆匆拿起外套，甚至没有看她一眼：「今晚可能不回来了。」</p><p>林知意站在窗边，看着他的车消失在夜色中。她打开手机，朋友圈里有人在机场偶遇了苏念安——「女神回国了！还是那么美！」照片里，那个和她相似度极高的女孩，正微笑着走出到达大厅。</p><p>她忽然就什么都明白了。什么爱情，什么婚姻，她从头到尾只是一个替身。</p><h2>第三章 离婚协议</h2><p>第二天早上，顾衍之回来的时候，林知意已经收拾好了行李。她把签好的离婚协议放在茶几上，平静得连自己都意外。</p><p>「什么意思？」顾衍之拿起协议，眉头紧皱。</p><p>「意思就是，我不做替身了。」林知意微微一笑，「你等的人回来了，我也该走了。」</p><p>顾衍之的脸色变了：「谁告诉你的？」</p><p>「重要吗？」</p><p>他沉默了很久，最后说了一句：「我没有把你当替身。」</p><p>林知意没有说话，只是拖着行李箱，头也不回地走出了这个住了三年的家。</p>`,
    faq: [
      { question: "《霸总的替身前妻》是HE还是BE？", answer: "本作是HE结局！虽然过程虐心，但最终霸总追妻火葬场，女主事业爱情双丰收，请放心阅读。" },
      { question: "这本书完结了吗？", answer: "已完结，共286章，番外3篇。全文可在po18平台阅读。" },
    ],
  },
  {
    id: 2,
    title: "穿成恶毒女配后我躺赢了",
    author: "墨香铜音",
    category: "穿书",
    slug: "穿书",
    description: "一觉醒来，她穿成了书里下场凄惨的恶毒女配。所有人都等着看她怎么作死，她直接摆烂躺平。没想到这一躺，男主男配们全都沦陷了——「她从不对我献殷勤，她好特别。」",
    rating: 4.9,
    reads: 2380000,
    tags: ["穿书", "沙雕", "万人迷"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20Chinese%20web%20novel%20cover%20with%20a%20beautiful%20girl%20in%20ancient%20Chinese%20hanfu%20dress%2C%20soft%20pink%20and%20gold%20color%20palette%2C%20cherry%20blossom%20branches%20framing%20the%20image%2C%20dreamy%20ethereal%20atmosphere%20on%20a%20cream%20background&width=400&height=560&seq=novel-cover-02&orientation=portrait",
    featured: true,
    rank: 2,
    content: `<h2>第一章 穿书了</h2><p>苏晚晚睁开眼的时候，发现自己躺在一张雕花大床上。头顶是绣着金线的幔帐，远处传来丫鬟的窃窃私语。她还以为自己在做梦，直到脑海中突然响起一道机械音——</p><p>「叮！恭喜宿主绑定恶毒女配系统。您的任务：按照原著剧情，给女主使绊子、抢男主、最后被男主一剑穿心。」</p><p>苏晚晚：「……」</p><p>她翻了个身，把被子蒙在头上：「不去。我要睡觉。」</p><p>系统：「？？？」</p><h2>第二章 躺平第一天</h2><p>按照原著，今天恶毒女配应该在花园里「偶遇」男主，然后故意摔倒在他怀里。苏晚晚选择在房间里吃点心。桃花酥真好吃。</p><p>系统急得团团转：「宿主！男主已经在花园等了半个时辰了！」</p><p>苏晚晚：「让他等，又不是我让他等的。」</p><p>系统：「可是剧情——」苏晚晚：「什么剧情？我穿书了，我就是剧情。」</p><p>系统沉默了。它从没见过这么嚣张的宿主。</p><h2>第三章 剧情崩了</h2><p>一个月后，原著剧情全线崩盘。男主因为她没来偶遇，反而注意到了她的「与众不同」。男配因为她没来陷害女主，觉得她「心地纯良」。就连女主本人，也因为少了恶毒女配的衬托，看起来……好像也没那么讨喜了？</p><p>苏晚晚躺在贵妃榻上，一边嗑瓜子一边看戏。系统：「宿主，现在剧情已经完全偏离了……」</p><p>苏晚晚：「嗯，瓜子不错。」</p>`,
    faq: [
      { question: "《穿成恶毒女配后我躺赢了》是什么类型的穿越文？", answer: "这是一本古言穿书沙雕文，女主穿成恶毒女配后全程摆烂，却意外收获万人迷体质，轻松搞笑不虐心。" },
      { question: "这本书完结了吗？", answer: "已完结，共312章，番外5篇。" },
    ],
  },
  {
    id: 3,
    title: "误惹全球首富",
    author: "叶非夜",
    category: "霸总",
    slug: "霸道总裁",
    description: "她被渣男劈腿后，在酒吧买醉，误把全球首富当成了牛郎。第二天醒来，她丢下两百块钱跑路。后来公司空降新总裁，男人西装革履地走进会议室，手里捏着两张皱巴巴的钞票：「昨晚的服务费，是不是少了点？」",
    rating: 4.7,
    reads: 1890000,
    tags: ["先婚后爱", "职场", "打脸"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20novel%20cover%20featuring%20a%20man%20in%20a%20luxury%20business%20suit%20with%20a%20skyline%20backdrop%2C%20warm%20amber%20lighting%2C%20elegant%20and%20sophisticated%20style%2C%20minimalist%20cream%20background%20with%20subtle%20gold%20accents&width=400&height=560&seq=novel-cover-03&orientation=portrait",
    featured: true,
    rank: 3,
    content: `<h2>第一章 买醉</h2><p>看到男朋友和闺蜜抱在一起的那一刻，沈柠觉得自己的世界崩塌了。她不是什么脆弱的女孩，但六年的感情说散就散，她还是没忍住红了眼眶。于是她做了每个失恋女孩都会做的事——去酒吧买醉。</p><p>她的酒量一向不好，三杯鸡尾酒下肚就开始天旋地转。恍惚中，她看到一个男人坐在角落，西装笔挺，气质矜贵。她脑子里只有一个念头：这个酒吧的牛郎质量真高。</p><p>「你，过来。」她朝他勾了勾手指。男人微微挑眉，似乎有些意外，但还是优雅地走了过来。</p><h2>第二章 两百块</h2><p>第二天早上，沈柠在酒店醒来，头昏脑涨。她看到身旁男人那张过分英俊的脸，以及床头柜上散落的衣物，瞬间清醒。她手忙脚乱地翻出钱包，抽出仅剩的两百块钱，放在床头柜上，然后逃也似的离开了房间。</p><p>她以为自己再也不会见到这个男人。直到一周后，公司被收购，新总裁莅临视察。会议室的门被推开，男人西装革履地走进来，全场起立鼓掌。沈柠手里的咖啡杯差点掉在地上。那张脸她永远不会忘记——尤其是此刻，他从口袋里拿出两张皱巴巴的百元大钞。</p><p>「昨晚的服务费，」他慢条斯理地说，「是不是少了点？」</p>`,
    faq: [
      { question: "《误惹全球首富》女主有事业线吗？", answer: "有！女主沈柠不是傻白甜，她是一名优秀的建筑设计师，在职场中的成长线非常精彩，和男主的感情发展也相当自然。" },
    ],
  },
  {
    id: 4,
    title: "重生之将门毒后",
    author: "千山茶客",
    category: "古言",
    slug: "古言",
    description: "前世她贵为皇后却被一杯毒酒了却残生。重生回到十五岁，她誓要护住家族，手撕仇人。那个前世对她冷若冰霜的大将军，这一世却步步紧逼——「沈妙，这辈子你跑不掉了。」",
    rating: 4.9,
    reads: 3560000,
    tags: ["重生", "宅斗", "将军"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20romance%20novel%20cover%20with%20a%20woman%20in%20elaborate%20ancient%20Chinese%20red%20wedding%20dress%2C%20golden%20phoenix%20embroidery%2C%20dramatic%20and%20powerful%20composition%2C%20vermilion%20and%20gold%20tones%20on%20a%20dark%20cream%20background&width=400&height=560&seq=novel-cover-04&orientation=portrait",
    featured: false,
    rank: 4,
    content: `<h2>第一章 重生</h2><p>沈妙是被疼醒的。那种深入骨髓的疼痛从指尖蔓延到心脏，让她猛地睁开双眼。入目是一顶天青色的帐幔，空气中弥漫着淡淡的药香。她愣了足足三秒，才意识到——自己没有死。</p><p>她明明记得，那杯毒酒入喉的灼烧感，还有那个男人冷漠的眼神。她贵为皇后，最终却落得一杯毒酒的下场。而这一切的始作俑者，是她最信任的枕边人。</p><p>「小姐！您终于醒了！」丫鬟碧落哭着扑过来。沈妙低头看了看自己的手——白皙纤细，没有岁月的痕迹。她回到了十五岁。</p><h2>第二章 将门之女</h2><p>前世她为了那个男人，疏远了家族，放弃了将门之女的骄傲。她以为自己换来的是爱情，殊不知只是一场精心设计的骗局。这一世，她不会再犯同样的错误。</p><p>「传令下去，」沈妙坐起身，眼底寒光乍现，「即刻起，沈家军加强操练，备战。」碧落愣住了。她家小姐什么时候开始关心军务了？沈妙没有解释。她只是在心里默默数着，距离那个人露出獠牙，还有不到三年的时间。</p>`,
    faq: [
      { question: "《重生之将门毒后》虐不虐？", answer: "前期有点虐，但重生后的女主非常飒爽，手撕渣男渣女不手软，大将军男主的追妻线也非常甜！" },
    ],
  },
  {
    id: 5,
    title: "偷偷藏不住",
    author: "竹已",
    category: "甜宠",
    slug: "甜宠",
    description: "十三岁那年，她偷偷喜欢上了哥哥的朋友。他是学校里最耀眼的存在，而她只是角落里不起眼的小透明。七年后，他在她的画展上驻足良久，低声说：「原来你画了我这么多年。」",
    rating: 4.8,
    reads: 4120000,
    tags: ["暗恋", "校园", "久别重逢"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20sweet%20youth%20romance%20Chinese%20novel%20cover%20with%20a%20young%20couple%20under%20cherry%20blossom%20trees%2C%20school%20uniform%2C%20pastel%20pink%20and%20soft%20peach%20tones%2C%20dreamy%20bokeh%20effect%2C%20warm%20spring%20sunlight%20on%20cream%20background&width=400&height=560&seq=novel-cover-05&orientation=portrait",
    featured: true,
    rank: 5,
    content: `<h2>第一章 初遇</h2><p>桑稚第一次见到段嘉许，是在哥哥的房间门口。那年她十三岁，刚上初一，个子还没窜起来，扎着两个马尾辫，抱着作业本傻乎乎地站在门口。门开了，出来的人不是她哥，而是一个她从没见过的少年。</p><p>少年很高，穿着白色的T恤，背着光，五官在阴影里看不真切。但他低头看向她的那一瞬，桑稚的心跳漏了一拍。后来她才知道，那是哥哥的室友，叫段嘉许。</p><p>「你是桑延的妹妹？」他的声音很轻，带着一点点笑意，「我叫段嘉许。」桑稚点了点头，脸红了。</p><h2>第二章 暗恋</h2><p>从那天起，桑稚开始了长达七年的暗恋。段嘉许是学校的风云人物——成绩好，打球厉害，长得又帅。而她只是个成绩一般、长相一般的普通女孩。她从来没想过要表白，只是默默地、偷偷地喜欢着。</p><p>她画了很多画。画他打球的样子，画他低头看书的样子，画他在阳光下微笑的样子。那些画被她小心地收在一个画夹里，谁也不给看。她想，等他毕业了，等他走远了，自己大概就会忘记的。</p><p>可是她忘了，有些人一旦刻在心底，就再也忘不掉。</p>`,
    faq: [
      { question: "《偷偷藏不住》有年龄差吗？", answer: "男女主相差五岁，男主是女主哥哥的大学室友。虽然年龄有差距，但感情线非常细腻自然，主打暗恋成真的甜蜜感。" },
    ],
  },
  {
    id: 6,
    title: "蚀骨危情",
    author: "淇老游",
    category: "虐恋",
    slug: "虐恋",
    description: "所有人都说她害死了他最爱的女人。于是他亲手把她送进监狱，让她受尽折磨。三年后她出狱，他递上一纸婚书：「嫁给我，或者回去。」她选择嫁给他。直到真相大白那天，他跪在她面前：「对不起，我错了。」",
    rating: 4.6,
    reads: 2980000,
    tags: ["虐恋", "误会", "追妻火葬场"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20dark%20romantic%20Chinese%20novel%20cover%20with%20a%20melancholic%20woman%20in%20the%20rain%2C%20monochrome%20with%20a%20single%20red%20rose%2C%20dramatic%20shadow%20and%20light%2C%20emotional%20and%20intense%20atmosphere%20on%20a%20dark%20cream%20background&width=400&height=560&seq=novel-cover-06&orientation=portrait",
    featured: false,
    rank: 6,
    content: `<h2>第一章 入狱</h2><p>简童从未想过，她的人生会因为一个莫须有的罪名而彻底崩塌。沈修瑾最爱的女人死了。所有人都指向了她——那个和沈修瑾青梅竹马、却一直被他厌恶的简童。</p><p>证据是伪造的，但她没有辩驳的机会。沈修瑾甚至没有看她一眼，只说了两个字：「带走。」然后她被送进了监狱。三年。一千零九十五天。她在那个暗无天日的地方，用三年时间磨掉了对这个男人所有的爱。</p><h2>第二章 出狱</h2><p>出狱那天，没有人来接她。简童站在监狱门口，刺眼的阳光让她下意识地眯起了眼睛。她已经很久没有见过真正的阳光了。深吸了一口气，拖着唯一的行李走在街头。</p><p>然后她看到了那辆黑色的迈巴赫。车窗缓缓降下，露出沈修瑾那张依旧冷峻的脸。「上车。」他说。简童没有动。「嫁给我，或者回去。」他的声音没有一丝温度，「你选。」</p>`,
    faq: [
      { question: "《蚀骨危情》虐到什么程度？", answer: "前期非常虐心，女主在监狱里的遭遇让人心疼。但后期男主知道真相后的追妻线也很有看点，HE结局。" },
    ],
  },
  {
    id: 7,
    title: "老婆粉了解一下",
    author: "春刀寒",
    category: "甜宠",
    slug: "甜宠",
    description: "作为一个合格的追星女孩，她最大的梦想就是离偶像近一点。万万没想到，一档恋爱综艺让她和顶流住了同一间房。全网都在磕他们的CP，只有她知道——这个男人真的在追她。",
    rating: 4.7,
    reads: 1750000,
    tags: ["娱乐圈", "追星", "恋爱综艺"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20bright%20Chinese%20entertainment%20romance%20novel%20cover%20with%20a%20girl%20holding%20a%20light%20stick%20at%20a%20concert%2C%20colorful%20stage%20lights%2C%20vibrant%20and%20youthful%20energy%2C%20pastel%20coral%20and%20peach%20tones%20on%20cream%20background&width=400&height=560&seq=novel-cover-07&orientation=portrait",
    featured: false,
    rank: 7,
    content: `<h2>第一章 我的爱豆</h2><p>陆悄悄追了沈砚三年。从他还是练习生的时候就开始追，看着他一步步从选秀节目出道，到成为顶流。她的手机壁纸是他，床头海报是他，就连电脑的开机密码都是他的生日。</p><p>室友说她魔怔了。陆悄悄不以为意：「追星女孩的快乐你不懂。」直到那天，她收到了一封神秘邮件。「恭喜您被选中参加《恋爱信号》综艺录制。」陆悄悄差点从椅子上摔下来。</p><p>《恋爱信号》是当下最火的恋爱综艺，而这一季的嘉宾名单里，赫然写着两个让她呼吸停止的字——沈砚。</p><h2>第二章 同居第一天</h2><p>综艺规则很简单：八位嘉宾入住恋爱小屋，通过日常相处培养感情。陆悄悄拖着行李箱站在别墅门口，手心全是汗。</p><p>门开了。沈砚穿着家居服，头发微乱，像是刚睡醒。他看了她一眼，忽然笑了：「是你啊。」陆悄悄的脑子「嗡」的一声。什么叫「是你啊」？他们认识吗？</p>`,
    faq: [
      { question: "《老婆粉了解一下》是双洁吗？", answer: "是！男女主都是彼此的初恋，感情线非常纯粹甜蜜，没有任何狗血第三者情节。" },
    ],
  },
  {
    id: 8,
    title: "掌中之物",
    author: "贝昕",
    category: "虐恋",
    slug: "虐恋",
    description: "她是正直善良的检察官助理，他是冷血无情的商业帝王。一场意外，她成了他的猎物。他用尽手段将她困在身边，她拼尽全力想要逃离。当爱与恨的界限逐渐模糊，是谁成了谁的掌中之物？",
    rating: 4.5,
    reads: 2670000,
    tags: ["虐恋", "强制爱", "复仇"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20dramatic%20Chinese%20dark%20romance%20novel%20cover%20with%20a%20man%20and%20woman%20in%20tense%20confrontation%2C%20one%20hand%20gripping%20a%20wrist%2C%20dark%20sophisticated%20color%20scheme%20with%20burgundy%20accents%2C%20intense%20emotional%20tension%20on%20a%20cream%20background&width=400&height=560&seq=novel-cover-08&orientation=portrait",
    featured: false,
    rank: 8,
    content: `<h2>第一章 猎物</h2><p>何妍这辈子做过最错的事，就是在那个雨夜接到了那个案子。傅慎行的名字在S市无人不知——他是商业帝国的掌权者，也是地下世界的无冕之王。没有人敢动他，除了何妍。</p><p>她只是一个刚入职的检察官助理，却不顾所有人的劝阻，执意要查清那桩命案背后的真相。她想，法律面前人人平等，总有人要为那些无声的受害者讨一个公道。但她低估了傅慎行的势力，也低估了这个男人的疯狂。</p><h2>第二章 囚笼</h2><p>「何检察官，」傅慎行坐在宽大的真皮椅子里，手里把玩着一支钢笔，「你觉得你能把我怎么样？」何妍冷冷地看着他：「至少我不会放弃。」</p><p>傅慎行笑了。那个笑容让她脊背发凉。「很好。」他站起来，居高临下地看着她，「从今天起，你就留在我身边。我倒要看看，是你的正义感硬，还是我的手段硬。」</p>`,
    faq: [
      { question: "《掌中之物》男主是真正的反派吗？", answer: "是的，傅慎行是真正的反派男主，不是传统意义上的霸总。他的手段非常极端，但故事也因此更加扣人心弦。注意：此作虐度较高。" },
    ],
  },
  {
    id: 9,
    title: "她的小梨涡",
    author: "唧唧的猫",
    category: "甜宠",
    slug: "甜宠",
    description: "全校都知道，校霸谢辞有两样东西不能碰——他的摩托车，还有隔壁班的许呦。偏偏转学生许呦不知道。她不仅碰了他的摩托车，还把他的一颗心也拐走了。多年后重逢，他把她抵在墙角：「这次，还跑吗？」",
    rating: 4.8,
    reads: 2210000,
    tags: ["校园", "校霸", "久别重逢"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20sweet%20Chinese%20youth%20school%20romance%20novel%20cover%20with%20a%20couple%20on%20a%20motorcycle%2C%20school%20building%20in%20background%2C%20warm%20sunset%20light%2C%20youthful%20and%20romantic%20atmosphere%2C%20soft%20peach%20and%20coral%20tones%20on%20a%20cream%20background&width=400&height=560&seq=novel-cover-09&orientation=portrait",
    featured: false,
    rank: 9,
    content: `<h2>第一章 转学生</h2><p>临城一中有两个人物最出名。一个是谢辞——打架从没输过的校霸，骑着一辆黑色的改装摩托车在校园里呼啸来去。另一个是许呦——新来的转学生，长得软软糯糯，笑起来有两个小梨涡。</p><p>所有人都说，这两个人八竿子打不着。直到那天，许呦不小心碰倒了谢辞停在教学楼下的摩托车。她蹲在地上，一块一块地捡起被摔碎的零件，眼眶红红的，梨涡却还倔强地挂在脸上。</p><p>谢辞从楼上走下来的时候，看到的就是这一幕。他本来想发火的——那辆摩托车是他最宝贝的东西。但不知道为什么，看到那个女孩红着眼眶还在笑的样子，他一个字都骂不出来。</p><h2>第二章 你来赔</h2><p>「你碰的？」谢辞走过去，居高临下地看着她。许呦抬起头，泪眼模糊地看着他：「对不起……我会赔的。」</p><p>「你怎么赔？」谢辞双手插兜，「这车改装花了三万。」许呦咬住下唇：「我……我打工。」谢辞被她认真的样子逗笑了。他蹲下来，和她平视：「不用你打工。从明天开始，你来给我补课。」许呦愣住了：「补课？」</p><p>「嗯，」谢辞站起来，嘴角微扬，「我数理化不及格，你来给我补，就当赔我的车。」许呦点了点头，梨涡又露出来了。谢辞别开眼，心想——真他妈可爱。</p>`,
    faq: [
      { question: "《她的小梨涡》是甜文吗？", answer: "超级甜！校园时期互怼互撩，重逢后更是甜蜜加倍。男女主从校霸和学霸的经典配对人设，但写得非常有新意。" },
    ],
  },
  {
    id: 10,
    title: "长风渡",
    author: "墨书白",
    category: "古言",
    slug: "古言",
    description: "她是扬州首富之女，他是纨绔不羁的顾家九公子。先婚后爱，从互相看不上到生死相托。乱世之中，她放下珠钗拿起算盘，撑起了整个家族；他脱去锦袍披上铠甲，守护了万里山河。",
    rating: 4.9,
    reads: 3120000,
    tags: ["先婚后爱", "双强", "乱世"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20romance%20novel%20cover%20with%20a%20noble%20couple%20in%20Tang%20dynasty%20style%20clothing%2C%20standing%20on%20a%20city%20wall%20overlooking%20a%20vast%20landscape%2C%20epic%20and%20romantic%2C%20warm%20golden%20and%20teal%20tones%20on%20a%20cream%20background&width=400&height=560&seq=novel-cover-10&orientation=portrait",
    featured: true,
    rank: 10,
    content: `<h2>第一章 婚事</h2><p>柳玉茹这辈子最不想嫁的人，就是顾九思。整个扬州城都知道，顾九公子是个不学无术的纨绔。他逛青楼、斗鸡走狗、一掷千金，除了正经事什么都干。偏偏柳家是商户，顾家是世家，这门婚事是柳父跪着求来的。</p><p>「嫁给他？」柳玉茹看着聘礼单子，冷笑一声，「我宁愿嫁给一条狗。」柳父脸色铁青地给了她一巴掌。那一巴掌打碎了她对父亲所有的幻想。她终于明白，在这个家里，她不过是一枚棋子。</p><h2>第二章 初遇</h2><p>新婚之夜，顾九思掀开盖头，看到的是一个满脸泪痕的新娘。他愣了愣，然后笑了：「怎么，嫁给我这么委屈？」</p><p>柳玉茹抬起头，恶狠狠地瞪他：「委屈。」顾九思被她瞪得一愣，随即哈哈大笑。他蹲下来，从袖子里掏出一方帕子递过去：「行了别哭了。我也不想娶你，咱俩凑合过吧。」柳玉茹愣住了。这个纨绔……好像和她想的不太一样。</p>`,
    faq: [
      { question: "《长风渡》和电视剧有什么不同？", answer: "原著小说在人物塑造和情节铺陈上更加细腻丰富，尤其是男女主的成长线——女主从闺阁少女到商业女强人，男主从纨绔公子到位极人臣，非常精彩。" },
    ],
  },
  {
    id: 11,
    title: "他从火光中走来",
    author: "耳东兔子",
    category: "现言",
    slug: "现言",
    description: "他是消防员，她是战地记者。他们在一起的时间很少，每一次见面都可能是最后一次。他说：「国家需要我，人民需要我，但我心里永远有一个位置是你的。」她说：「你去守护世界，我来守护你。」",
    rating: 4.7,
    reads: 1450000,
    tags: ["职业", "救赎", "温暖"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20Chinese%20modern%20romance%20novel%20cover%20with%20a%20firefighter%20silhouette%20against%20orange%20flames%2C%20warm%20and%20heroic%20atmosphere%2C%20soft%20focus%2C%20emotional%20and%20touching%20style%2C%20orange%20and%20dark%20cream%20background&width=400&height=560&seq=novel-cover-11&orientation=portrait",
    featured: false,
    rank: 11,
    content: `<h2>第一章 火灾</h2><p>林陆骁第一次见到南初，是在一场大火里。那天的火势很大，整栋居民楼都被浓烟笼罩。他带队员冲进去的时候，看到一个女孩抱着一条小狗，蹲在角落里瑟瑟发抖。</p><p>「别怕，」他抱起女孩，声音沉稳，「我带你出去。」女孩紧紧地抓住他的消防服，指甲几乎嵌进了布料里。到了安全地带，她才抬起头，一双眼睛亮得惊人：「谢谢你。」那是林陆骁这辈子见过的最好看的眼睛。</p><h2>第二章 使命</h2><p>再次见面，是在半年后。南初作为战地记者，在采访消防队的时候，一眼就认出了他。「是你！」她兴奋地跑过来，「那个在火灾里救我的消防员！」</p><p>林陆骁点了点头：「你也当记者了。」南初笑了：「嗯，我想把你这种人的故事写出来，让更多人知道。」林陆骁心里一动，脸上却没有什么表情。他只是说：「没什么好写的，这是我的工作。」</p>`,
    faq: [
      { question: "《他从火光中走来》结局是HE吗？", answer: "是HE！虽然男女主的职业都很危险，但最终两人都平安，感情也修成正果。整本书充满了温暖和力量，非常治愈。" },
    ],
  },
  {
    id: 12,
    title: "黑月光拿稳BE剧本",
    author: "藤萝为枝",
    category: "穿书",
    slug: "穿书",
    description: "她穿成了书里注定要死的白月光。按照剧本，她将在第三章被男主一掌拍死。黎苏苏决定——不干了。她连夜收拾包袱跑路，却在城门口被一袭黑衣的男人堵住：「夫人，这么晚了要去哪？」",
    rating: 4.6,
    reads: 1980000,
    tags: ["穿书", "修仙", "追妻"],
    coverImage: "https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20romance%20novel%20cover%20with%20a%20woman%20in%20flowing%20white%20immortal%20robes%2C%20ethereal%20moonlight%2C%20magical%20sparkles%2C%20celestial%20and%20dreamy%20atmosphere%2C%20soft%20silver%20and%20lavender%20tones%20on%20cream%20background&width=400&height=560&seq=novel-cover-12&orientation=portrait",
    featured: false,
    rank: 12,
    content: `<h2>第一章 穿成白月光</h2><p>黎苏苏睁开眼的时候，入目是一间古色古香的寝殿。脑海中涌入大量不属于她的记忆——她穿书了。穿进了那本她吐槽了三天三夜的虐文里，成了那个注定要死的白月光。</p><p>按照原著，她会在第三章被男主一掌拍死。而现在，她已经站在了第二章的末尾。黎苏苏看看窗外，月亮正圆。很好，月黑风高，正是跑路的好时候。</p><h2>第二章 跑路</h2><p>她动作利索地收拾好包袱——银子、干粮、换洗衣物，还有那把她从兵器库里偷来的短剑。黎苏苏深吸一口气，推开窗户，翻身跃下。她是练过的。原著里这个白月光是个修仙者，虽然天赋一般，但轻功还行。</p><p>一路狂奔，眼看城门就在眼前。黎苏苏的心跳加速，差一点，就差一点——一袭黑衣的男人从天而降，稳稳地落在她面前。黎苏苏刹住脚步，手里的包袱差点掉在地上。「夫人。」男人低沉的声音在夜风中格外清晰，「这么晚了，要去哪？」</p>`,
    faq: [
      { question: "《黑月光拿稳BE剧本》男主为什么叫黑月光？", answer: "因为原著中男主是反派设定，手段狠辣，但女主穿书后他用尽全力保护她，从不被理解到被她温暖，是一个非常有魅力的角色。" },
    ],
  },
];

export const categories = [
  { name: "全部", slug: "全部", icon: "ri-book-read-line" },
  { name: "甜宠", slug: "甜宠", icon: "ri-heart-line" },
  { name: "虐恋", slug: "虐恋", icon: "ri-rainy-line" },
  { name: "霸总", slug: "霸道总裁", icon: "ri-vip-crown-line" },
  { name: "古言", slug: "古言", icon: "ri-ancient-gate-line" },
  { name: "现言", slug: "现言", icon: "ri-building-line" },
  { name: "穿书", slug: "穿书", icon: "ri-pages-line" },
];

export const testimonials = [
  {
    name: "小雨",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style%2C%20neutral%20cream%20background&width=80&height=80&seq=avatar-01&orientation=squarish",
    text: "自从发现了po18脸红心跳，每天晚上睡前都要刷一会儿！推荐的小说本本都好看，评论区也超有爱，找到了好多志同道合的书友。",
    rating: 5,
  },
  {
    name: "柠檬不酸",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20portrait%20with%20glasses%2C%20gentle%20smile%2C%20indoor%20natural%20light%2C%20casual%20professional%20look%2C%20neutral%20cream%20background&width=80&height=80&seq=avatar-02&orientation=squarish",
    text: "分类做得特别好！我超爱看穿书文，在po18上找到了好多宝藏。每篇推荐都写得很用心，能感受到编辑是真的喜欢这些书才推荐的。",
    rating: 5,
  },
  {
    name: "月亮不睡我不睡",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20portrait%20with%20long%20hair%2C%20bright%20smile%2C%20outdoor%20natural%20light%2C%20friendly%20and%20approachable%2C%20neutral%20cream%20background&width=80&height=80&seq=avatar-03&orientation=squarish",
    text: "以前找书看总是大海捞针，现在有了排行榜和分类推荐，追书效率直线上升！霸总文是我的最爱，每一本都让人脸红心跳！",
    rating: 5,
  },
  {
    name: "星星点灯",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20portrait%20with%20short%20bob%20haircut%2C%20elegant%20smile%2C%20warm%20indoor%20lighting%2C%20stylish%20and%20modern%2C%20neutral%20cream%20background&width=80&height=80&seq=avatar-04&orientation=squarish",
    text: "po18的阅读指南做得太贴心了！每本书都有详细的介绍和FAQ，追文前先看看就不会踩雷。已经推荐给身边所有看小说的姐妹了！",
    rating: 5,
  },
];

export const siteInfo = {
  name: "po18脸红心跳",
  description: "po18脸红心跳是深受读者喜爱的言情小说平台内容标签，汇聚大量让人脸红心跳的甜宠、虐恋、霸总等热门故事。为你精选最受欢迎的脸红心跳系列小说，带你沉浸在每一个动人的爱情世界中。",
  keywords: "po18脸红心跳,po18言情小说,脸红心跳甜宠小说,po18热门推荐,言情小说阅读,甜宠霸总小说,po18小说排行榜",
  url: "https://po18-faceheart.com",
  email: "contact@po18-faceheart.com",
  established: "2020",
  readerCount: "500万+",
  novelCount: "20000+",
  reviewCount: "100万+",
};